import React, { useEffect, useMemo, useState } from 'react'
import Sidebar from '../../../../components/Sidebar/Sidebar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import SeedsLogo from '../../../../assets/images/SeedsLogo.png';
import UserProfileDropdown from '../../../../components/UserProfile/UserProfile';
import { useDispatch, useSelector } from 'react-redux';
import { faCheck, faClose, faFileAlt, faHourglassHalf, faTimes } from '@fortawesome/free-solid-svg-icons';
import { getApplicationListBranchwise } from '../../../../redux/TeamOverviewReducer/action';
import { getApplicationStatusList } from '../../../../redux/ApplicationReducer/action';
import { getAllActiveBranches, getApplicationsSummary } from '../../../../redux/BranchReducer/action';
import { getOfficers } from '../../../../redux/UserReducer/action';
import { Col, Row, Spinner } from 'react-bootstrap';
import ErrorState from '../../../../components/ErrorState/ErrorState';
import { groupOfficersByRole } from '../../../../utils/user';
import StaffTable from '../../components/StaffTable/StaffTable';
import './TeamOverview.css';
import BranchSelector from '../../components/BranchSelector/BranchSelector';
import ActiveFilterPills from '../../components/ActiveFilterPills/ActiveFilterPills';
import DateRangeFilter from '../../components/DateRangeFilter/DateRangeFilter';
import '../../../TVRscreens/TVRscreen.css';
import StaffView from '../StaffView/StaffView';
import ApplicationView from '../ApplicationView/ApplicationView';
import { useSearchParams } from 'react-router-dom';
import { resetFiltersDefault } from '../../../../utils/common';
import { OFFICER_APPLICATION_FILTERS, TEAM_DASHBOARD_SUMMARY_FILTERS } from '../../../../config/application';

const TeamOverview = () => {

  const { loading, error, branchwiseApplicationsList, officerProfile, applicationStatusList, officers, allActiveBranches, applicationsSummary } = useSelector((store) => {
    return {
      loading: store.TeamOverviewReducer.loading,
      error: store.TeamOverviewReducer.error,
      branchwiseApplicationsList: store.TeamOverviewReducer.branchwiseApplicationsList,
      officerProfile: store.UserReducer.officerProfile,
      applicationStatusList: store.ApplicationReducer.applicationStatusList,
      officers: store.UserReducer.officers,
      allActiveBranches: store.BranchReducer.allActiveBranches,
      applicationsSummary: store.BranchReducer.applicationsSummary,
    }
  });

  const [currentPage, setCurrentPage] = useState(parseInt(sessionStorage.getItem('currentPage')) || 1);
  const [limit, setLimit] = useState(parseInt(sessionStorage.getItem('limit')) || 10);
  const totalCount = parseInt(sessionStorage.getItem('totalCount')) || 0;
  const totalPages = Math.ceil(totalCount / limit);

  // Owned here (not inside StaffView) so it survives switching to
  // Application View and back - StaffView unmounts on every tab switch.
  const [staffCurrentPage, setStaffCurrentPage] = useState(parseInt(sessionStorage.getItem('staffCurrentPage')) || 1);

  useEffect(() => {
    sessionStorage.setItem('staffCurrentPage', staffCurrentPage.toString());
  }, [staffCurrentPage]);

  const [searchParams, setSearchParams] = useSearchParams();
  // const [activeTab, setActiveTab] = useState(searchParams.get("tab") || 'staff-view');
  const activeTab = searchParams.get("tab") || 'staff-view';

  const storedFilters = JSON.parse(sessionStorage.getItem('bwApplicationListFilters')) || {};
  const storedAppFilters = JSON.parse(sessionStorage.getItem('branchApplicationFilters')) || {};
  const storedDashboardSummaryFilters = JSON.parse(sessionStorage.getItem('dashboardSummaryFilters')) || {};
  const isHOUser = ["HO"].includes(officerProfile?.branch?.branch_code);
  const hasPrimarySecondaryBranches = ["RO", "BM", "BCM"].includes(officerProfile?.roleMaster?.short_name);
  // const loggedInOfficerSecondaryBranches = officers?.officers?.[0]?.officer_details?.[0]?.secondary_branches || [];
  const loggedInOfficer = useMemo(() => {
    return officers?.officers?.[0]?.officer_details?.find(
      officer => officer.officer_id === officerProfile?.officer_id
    );
  }, [officers?.officers, officerProfile?.officer_id]);

  const loggedInOfficerSecondaryBranches = useMemo(() => loggedInOfficer?.secondary_branches || [], [loggedInOfficer?.secondary_branches]);

  const [bwApplicationListFilters, setBwApplicationListFilters] = useState({
    date_from: storedFilters?.date_from || '',
    date_to: storedFilters?.date_to || '',
    // branch_code: storedFilters?.branch_code || (isHOUser ? "" : officerProfile?.branch?.branch_code) || ""
    // branch_code: (isHOUser ? "" : (officerProfile?.branch?.branch_code || storedFilters?.branch_code)) || ""
    branch_code: ""
  });

  const [branchApplicationFilters, setBranchApplicationFilters] = useState({
      ro_id: storedAppFilters?.ro_id || "",
      application_id: storedAppFilters?.application_id || "",
      application_stage_name: storedAppFilters?.application_stage_name || "",
      current_application_bucket: storedAppFilters?.current_application_bucket || "",
      application_status: storedAppFilters?.application_status || "",
      application_owner: storedAppFilters?.application_owner || "",
      ro_employee_ids: storedAppFilters?.ro_employee_ids || [],
      bm_employee_ids: storedAppFilters?.bm_employee_ids || [],
      bcm_employee_ids: storedAppFilters?.bcm_employee_ids || [],
      branch_code: storedAppFilters?.branch_code || "",
      customer_name: storedAppFilters?.customer_name || "",
      customer_pan: storedAppFilters?.customer_pan || "",
      phone_number: storedAppFilters?.phone_number || "",
      lead_id: storedAppFilters?.lead_id || "",
      seeds_id: storedAppFilters?.seeds_id || "",
      external_customer_id: storedAppFilters?.external_customer_id || "",
      is_ro_completed: storedAppFilters?.is_ro_completed || "",
      is_bm_completed: storedAppFilters?.is_bm_completed || "",
      is_bcm_completed: storedAppFilters?.is_bcm_completed || "",
      is_rejected: storedAppFilters?.is_rejected || "",
      global_search: storedAppFilters?.global_search || "",
      sort_by: storedAppFilters?.sort_by || "",
      sort_order: storedAppFilters?.sort_order || "",
      start_date: storedAppFilters?.start_date || "",
      end_date: storedAppFilters?.end_date || "",
  });

  const [selectedOwner, setSelectedOwner] = useState(
      JSON.parse(sessionStorage.getItem("branchApplicationFilters"))?.application_owner || ""
  );

  const [branchFilters, setBranchFilters] = useState({
    branch_name: '',
    branch_code: '',
  });

  const [officerFilters, setOfficerFilters] = useState({
    is_active: '',
    emp_id: officerProfile?.emp_id || ''
  });

  const [dashboardSummaryFilters, setDashboardSummaryFilters] = useState({
    startDate: storedDashboardSummaryFilters?.startDate || '',
    endDate: storedDashboardSummaryFilters?.endDate || '',
    branch_code: storedDashboardSummaryFilters?.branch_code || '',
  });

  const dispatch = useDispatch();

  const groupedOfficers = useMemo(() => groupOfficersByRole(branchwiseApplicationsList?.officer_wise_breakdown), [branchwiseApplicationsList]);

  const handlePageChange = (newPage) => {
    // Ensure we're working with 1-based pagination
    const pageToSet = Math.max(1, Math.min(newPage, totalPages));
    setCurrentPage(pageToSet);
    sessionStorage.setItem('currentPage', pageToSet.toString());
  };


  useEffect(() => {
    dispatch(
      getApplicationStatusList({
        is_active: true,
      }),
    );
  }, [dispatch]);
  
  useEffect(() => {
    dispatch(getAllActiveBranches(1, 20000, branchFilters));
  }, [dispatch, branchFilters, isHOUser]);

  useEffect(() => {
    dispatch(getOfficers(1, 20000, officerFilters));
  }, [dispatch, officerFilters]);

  useEffect(() => {
    // if(bwApplicationListFilters?.branch_code){
      dispatch(getApplicationListBranchwise(bwApplicationListFilters));
    // }
  }, [dispatch, bwApplicationListFilters, isHOUser]);

  useEffect(() => {
      console.log("selectedOwner", selectedOwner);
  }, [selectedOwner]);

  // useEffect(() => {
  //   if (isHOUser && allActiveBranches?.length > 0 && !bwApplicationListFilters.branch_code) {
  //     setBwApplicationListFilters((prev) => ({
  //       ...prev,
  //       branch_code: allActiveBranches?.[0]?.branch_code
  //     }));
  //   }
  // }, [isHOUser, allActiveBranches, bwApplicationListFilters.branch_code]);

  useEffect(() => {
    sessionStorage.setItem("bwApplicationListFilters", JSON.stringify(bwApplicationListFilters));
  }, [bwApplicationListFilters]);

  useEffect(() => {
    dispatch(getApplicationsSummary(dashboardSummaryFilters));
  }, [dispatch, dashboardSummaryFilters]);

  // --- KPI computed from current page data ---
  const appKpiData = useMemo(() => {
    let branchwiseMetaData = branchwiseApplicationsList?.metaData;

    const counts = [
      { 
        key: 'total', 
        label: "Total Files", 
        value: branchwiseMetaData?.total_application_count, 
        icon: faFileAlt 
      },
      { 
        key: 'in-progress', 
        label: "In Progress", 
        value: branchwiseMetaData?.in_progress_count, 
        icon:  faHourglassHalf
      },
      { 
        key: 'sanction', 
        label: "Sanctioned", 
        value: branchwiseMetaData?.completed_count, 
        icon: faCheck
      },
      { 
        key: 'reject', 
        label: "Rejected", 
        value: branchwiseMetaData?.reject_count, 
        icon:  faClose
      }
    ];

    return counts;
  }, [branchwiseApplicationsList?.metaData]);

  // --- KPI computed for current branch ---
  const branchApplicationsKpiData = useMemo(() => {
    const counts = [
      { 
        key: 'total_cases', 
        label: "Total Cases", 
        value: applicationsSummary.all_application_count, 
        filterValue: "",
      },
      { 
        key: 'pending_bm', 
        label: "Pending with BM", 
        value: applicationsSummary.pending_bm_count, 
        filterValue: "PENDING_IN_BM",
      },
      { 
        key: 'pending_bcm', 
        label: "Pending with BCM", 
        value: applicationsSummary.pending_bcm_count, 
        filterValue: "PENDING_IN_BCM",
      },
      { 
        key: 'pending_ro', 
        label: "Pending with RO", 
        value: applicationsSummary.pending_ro_count, 
        filterValue: "PENDING_IN_RO",
      },
      { 
        key: 'pending_ho', 
        label: "Pending with HO", 
        value: (applicationsSummary.tvr_pending_count + applicationsSummary.sanction_pending_count), 
        filterValue: "PENDING_IN_HO",
      },
      { 
        key: 'active_customer', 
        label: "Active Customer", 
        value: applicationsSummary.active_customer_count,
        filterValue: "ACTIVE_CUSTOMER", 
      },
      { 
        key: 'rejected', 
        label: "Rejected", 
        value: applicationsSummary.total_rejected, 
        filterValue: "REJECTED",
      },
      // { 
      //   key: 'expired', 
      //   label: "Loan Expired", 
      //   value: applicationsSummary.loan_expired_count, 
      // },
      { 
        key: 'onboarding_inprogress_customer', 
        label: "Onboarding In Progress Customer", 
        value: applicationsSummary.customer_onboarding_progress, 
        filterValue: "ONBOARDING_INPROGRESS_CUSTOMER",
      },
    ];

    return counts;
  }, [applicationsSummary]);

  const masterStatusList = useMemo(() => {
    return applicationStatusList || []
  }, [applicationStatusList]);

  // Distinct Parent Stages
  const parentStageOptions = useMemo(() => {
    return [
      ...new Set(masterStatusList?.map((item) => {
        return item.parent_stage_name?.replace(/[\s-]+/g, '_')?.toLowerCase()
      })),
    ];
  }, [masterStatusList]);

  const stageColumns = useMemo(() => {
    const seenKeys = new Set(); // tracks keys you've already added, NOT the {key,label} objects themselves
    const columns = [];

    masterStatusList?.forEach((item) => {
      const key = item.parent_stage_name?.replace(/[\s-]+/g, '_')?.toLowerCase();

      if (seenKeys.has(key)) return; // already added this stage, skip

      seenKeys.add(key);
      const label = item.parent_stage_name?.replace(/[\s]+/g, ' ');
      columns.push({ key, label });
    });

    return columns;
  }, [masterStatusList]);

  const handleClearFilters = () => {
    const clearedFilters = {
      date_from: "" ,
      date_to: "",
      // branch_code: (isHOUser ? "" : officerProfile?.branch?.branch_code) || ""
      branch_code: ""
    };

    const clearedDashboardSummaryFilters = resetFiltersDefault(dashboardSummaryFilters, TEAM_DASHBOARD_SUMMARY_FILTERS);
    const clearedApplicationFilters = {
      ...resetFiltersDefault(branchApplicationFilters, OFFICER_APPLICATION_FILTERS),
      global_search: "",
      start_date: "",
      end_date: "",
    };

    setBwApplicationListFilters(clearedFilters);
    setDashboardSummaryFilters(clearedDashboardSummaryFilters);
    setBranchApplicationFilters(clearedApplicationFilters);

    handlePageChange(1);

    sessionStorage.setItem("bwApplicationListFilters", JSON.stringify(clearedFilters));
    sessionStorage.setItem("dashboardSummaryFilters", JSON.stringify(clearedDashboardSummaryFilters));
    sessionStorage.setItem("branchApplicationFilters", JSON.stringify(clearedApplicationFilters));
  };


  const branchCodeOptions = useMemo(() => {
    return isHOUser ? 
        [
          ...(allActiveBranches?.map((branch) => {
              return {
                  key: branch.branch_code,
                  value: branch.branch_code,
                  label: `${branch.branch_name} - ${branch.branch_code}`
              }
          }))
        ] :
      hasPrimarySecondaryBranches ?
          [
            ...(loggedInOfficerSecondaryBranches || [])?.map((branch) => {
                return {
                    key: branch.branch_code,
                    value: branch.branch_code,
                    label: `${branch.branch_name} - ${branch.branch_code} (S)`
                }
            }),
            {
                key: officerProfile?.branch?.branch_code,
                value: officerProfile?.branch?.branch_code,
                label: `${officerProfile?.branch?.branch_name} - ${officerProfile?.branch?.branch_code} (P)`
            }
          ] :
          [
            {
                key: officerProfile?.branch?.branch_code,
                value: officerProfile?.branch?.branch_code,
                label: `${officerProfile?.branch?.branch_name} - ${officerProfile?.branch?.branch_code}`
            }
          ];
  }, [loggedInOfficerSecondaryBranches, officerProfile, allActiveBranches, isHOUser, hasPrimarySecondaryBranches])

  // Labels for the filter pills shown near the Staff View/Application View
  // tabs - sort_by/sort_order are excluded since they're a sort choice, not
  // a filter, and everything else here lives on branchApplicationFilters.
  const FILTER_PILL_LABELS = {
    application_owner: 'Application Owner',
    current_application_bucket: 'Parent Stage',
    application_stage_name: 'Application Stage',
    ro_employee_ids: 'RO Employee IDs',
    bm_employee_ids: 'BM Employee IDs',
    bcm_employee_ids: 'BCM Employee IDs',
    application_id: 'Application ID',
    seeds_id: 'Application Number',
    customer_name: 'Customer Name',
    customer_pan: 'Customer PAN',
    phone_number: 'Phone Number',
    lead_id: 'Lead ID',
    external_customer_id: 'Customer ID',
    global_search: 'Search',
  };

  // branch_code and the date range are mirrored across bwApplicationListFilters,
  // dashboardSummaryFilters and branchApplicationFilters (every handler that
  // sets one sets all three) - clearing them here keeps all three in sync
  // instead of only clearing one and leaving the others stale.
  const handleClearSingleFilter = (key) => {
    if (key === 'branch_code') {
      setBwApplicationListFilters((prev) => ({ ...prev, branch_code: '' }));
      setDashboardSummaryFilters((prev) => ({ ...prev, branch_code: '' }));
      setBranchApplicationFilters((prev) => {
        const updated = { ...prev, branch_code: '' };
        sessionStorage.setItem("branchApplicationFilters", JSON.stringify(updated));
        return updated;
      });
    } else if (key === 'date_range') {
      setBwApplicationListFilters((prev) => ({ ...prev, date_from: '', date_to: '' }));
      setDashboardSummaryFilters((prev) => ({ ...prev, startDate: '', endDate: '' }));
      setBranchApplicationFilters((prev) => {
        const updated = { ...prev, start_date: '', end_date: '' };
        sessionStorage.setItem("branchApplicationFilters", JSON.stringify(updated));
        return updated;
      });
    } else {
      const config = OFFICER_APPLICATION_FILTERS.find((field) => field.key === key);
      const defaultValue = config ? config.defaultValue : (Array.isArray(branchApplicationFilters[key]) ? [] : '');

      setBranchApplicationFilters((prev) => {
        const updated = { ...prev, [key]: defaultValue };
        sessionStorage.setItem("branchApplicationFilters", JSON.stringify(updated));
        return updated;
      });

      if (key === 'application_owner') setSelectedOwner('');
    }

    handlePageChange(1);
  };

  const activeFilterPills = useMemo(() => {
    const pills = [];

    if (bwApplicationListFilters.branch_code) {
      const branchOption = branchCodeOptions.find((b) => b.value === bwApplicationListFilters.branch_code);
      pills.push({
        key: 'branch_code',
        label: 'Branch',
        value: branchOption?.label || bwApplicationListFilters.branch_code,
        onClear: () => handleClearSingleFilter('branch_code'),
      });
    }

    if (bwApplicationListFilters.date_from || bwApplicationListFilters.date_to) {
      pills.push({
        key: 'date_range',
        label: 'Date Range',
        value: `${bwApplicationListFilters.date_from || '…'} - ${bwApplicationListFilters.date_to || '…'}`,
        onClear: () => handleClearSingleFilter('date_range'),
      });
    }

    Object.entries(FILTER_PILL_LABELS).forEach(([key, label]) => {
      const value = branchApplicationFilters[key];
      const isEmpty = Array.isArray(value) ? value.length === 0 : !value;
      if (isEmpty) return;

      pills.push({
        key,
        label,
        value: Array.isArray(value) ? value.join(', ') : value,
        onClear: () => handleClearSingleFilter(key),
      });
    });

    return pills;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bwApplicationListFilters, branchApplicationFilters, branchCodeOptions]);

  const TEAM_OVERVIEW_TABS = [
      {
          key: "staff-view",
          name: "Staff View",
          component: <StaffView
            groupedOfficers={groupedOfficers}
            stageColumns={stageColumns}
            handlePageChange={handlePageChange}
            branchApplicationFilters={branchApplicationFilters}
            setBranchApplicationFilters={setBranchApplicationFilters}
            staffCurrentPage={staffCurrentPage}
            setStaffCurrentPage={setStaffCurrentPage}
          />
      },
      {
          key: "application-view",
          name: "Application View",
          component: <ApplicationView 
            branchOptions={branchCodeOptions}
            bwApplicationListFilters={bwApplicationListFilters}
            setBwApplicationListFilters={setBwApplicationListFilters}
            branchApplicationFilters={branchApplicationFilters}
            setBranchApplicationFilters={setBranchApplicationFilters}
            handlePageChange={handlePageChange}
            currentPage={currentPage}
            limit={limit}
            totalPages={totalPages}
          />
      },
  ]

  const hasActiveFilters = useMemo(() => {
    const hasBwFilters =
      !!bwApplicationListFilters.date_from ||
      !!bwApplicationListFilters.date_to ||
      !!bwApplicationListFilters.branch_code;

    const hasApplicationFilters = Object.entries(branchApplicationFilters).some(
      ([key, value]) => {
        // Ignore pagination/sorting if you don't want them considered
        if (["sort_by", "sort_order"].includes(key)) return false;

        if (Array.isArray(value)) {
          return value.length > 0;
        }

        return value !== "" && value !== null && value !== undefined;
      }
    );

    return hasBwFilters || hasApplicationFilters;
  }, [bwApplicationListFilters, branchApplicationFilters]);

  // console.log({ list: branchwiseApplicationsList?.metaData, parentStageOptions, stageColumns });

  // console.log({ ofw: branchwiseApplicationsList?.officer_wise_breakdown, loggedInOfficerSecondaryBranches: officers?.officers?.[0]?.officer_details?.[0]?.secondary_branches })

  if (loading) {
    return (
      <div className="applicationsDashboardContainer">
        <div className="applicationsDashboard">
          <Sidebar />

          <div className="dashboardMainContent">
            <div className="contentHeader">
              <div className="userLogo">
                <img src={SeedsLogo} alt="logo" className="SeedsLogo" />
              </div>
              <div className="headerRightPanel">
                <UserProfileDropdown />
              </div>
            </div>

            <div className="pageContentWrapper">
              {/* Sticky Header Section */}
              <div className="stickyHeaderContainer">
                {/* Page Header */}
                <div className="pageHeaderSection">
                  <div className="pageActions">
                    <h2>Team Overview</h2>
                  </div>
                </div>
              </div>

              <Spinner />
            </div>
          </div>
        </div>
      </div>

    );
  }

  if (error) {
    return (
      <div className="applicationsDashboardContainer">
        <div className="applicationsDashboard">
          <Sidebar />

          <div className="dashboardMainContent">
            <div className="contentHeader">
              <div className="userLogo">
                <img src={SeedsLogo} alt="logo" className="SeedsLogo" />
              </div>
              <div className="headerRightPanel">
                <UserProfileDropdown />
              </div>
            </div>

            <div className="pageContentWrapper">
              {/* Sticky Header Section */}
              <div className="stickyHeaderContainer">
                {/* Page Header */}
                <div className="pageHeaderSection">
                  <div className="pageActions">
                    <h2>Team Overview</h2>
                  </div>
                </div>
              </div>

              <ErrorState 
                message={error}
                onRetry={() => dispatch(getApplicationListBranchwise(bwApplicationListFilters))}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="applicationsDashboardContainer">
      <div className="applicationsDashboard">
        <Sidebar />

        <div className="dashboardMainContent">
          <div className="contentHeader">
            <div className="userLogo">
              <img src={SeedsLogo} alt="logo" className="SeedsLogo" />
            </div>
            <div className="headerRightPanel">
              <UserProfileDropdown />
            </div>
          </div>

          <div className="pageContentWrapper">
            {/* Sticky Header Section */}
            <div className="stickyHeaderContainer">
              {/* Page Header */}
              <div className="pageHeaderSection">
                <div className="pageActions">
                  <h2>Team Overview</h2>
                  <div className="team-filter-section">
                    <div className="branch-container">
                      <div className="branch-selector">
                        {/* <span>
                          Branch
                        </span> */}
                        <div className="branch-filter">
                          <BranchSelector 
                            officerProfile={officerProfile}
                            secondaryBranches={loggedInOfficerSecondaryBranches}
                            allActiveBranches={allActiveBranches}
                            value={bwApplicationListFilters.branch_code}
                            onChange={(e) => {
                              setBwApplicationListFilters((prev) => ({
                                ...prev,
                                branch_code: e.target.value
                              }));

                              setBranchApplicationFilters((prev) => ({
                                ...prev,
                                branch_code: e.target.value
                              }));

                              setDashboardSummaryFilters((prev) => ({
                                ...prev,
                                branch_code: e.target.value
                              }));

                              handlePageChange(1);
                            }}
                          />
                          <span className='member-count-badge'>
                            {branchwiseApplicationsList?.officer_wise_breakdown?.length || 0}&nbsp;member(s)
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* <div className="other-filters"> */}
                    <div className="filterButtons">
                        {hasActiveFilters && 
                          <button className="clearFiltersBtn" onClick={handleClearFilters}>
                              <FontAwesomeIcon icon={faTimes} />
                              Clear Filters
                          </button>
                        }
                          <DateRangeFilter 
                            dateFrom={bwApplicationListFilters?.date_from}
                            dateTo={bwApplicationListFilters?.date_to}
                            onApply={(dates) => {
                              setBwApplicationListFilters((prev) => ({
                                ...prev,
                                ...dates
                              }));

                              setDashboardSummaryFilters((prev) => ({
                                ...prev,
                                startDate: dates?.date_from,
                                endDate: dates?.date_to,
                              }))

                              setBranchApplicationFilters((prev) => ({
                                ...prev,
                                start_date: dates?.date_from,
                                end_date: dates?.date_to,
                              }))

                              handlePageChange(1);
                            }}
                          />
                    </div>
                  </div>
                </div>
              </div>


              {/* --- KPI Metric Cards --- */}
              {/* <div className="appKpiStrip">
                {
                  appKpiData?.map((data) => {
                    return (
                      <div className={`appKpiCard appKpi-${data.key}`}>
                        <div className="appKpiIcon">
                          <FontAwesomeIcon icon={data.icon} />
                        </div>
                        <div className="appKpiInfo">
                          <span className="appKpiValue">
                            {data?.value?.toLocaleString()}
                          </span>
                          <span className="appKpiLabel">{data?.label}</span>
                        </div>
                      </div>
                    )
                  })
                }
              </div> */}

              <div className='application-summary-section'>
                <Row className="g-3 align-items-stretch">
                  {
                    branchApplicationsKpiData?.map((data, index) => {
                      return (
                        <Col key={index} className="d-flex" onClick={() => console.log("Col clicked")}>
                          <div 
                            className={`stage-card flex-fill ${
                              selectedOwner === data.filterValue ? "active-stage-card" : ""
                            }`}
                            onClick={() => {
                                const newValue = selectedOwner === data.filterValue ? "" : data.filterValue;
                                // console.log({ newValue });

                                setSelectedOwner(newValue);

                                let updatedFilters = {
                                  ...branchApplicationFilters,
                                  application_owner: newValue,
                                }

                                setBranchApplicationFilters(updatedFilters);

                                sessionStorage.setItem("branchApplicationFilters", JSON.stringify(updatedFilters));
                                handlePageChange(1);
                                setSearchParams({ tab: "application-view" });
                            }}
                          >
                            <div className="stage-card-body">
                              <span className="branch-card-count">
                                {data?.value?.toLocaleString()}
                              </span>
                              <span className="branch-card-title">{data?.label}</span>
                            </div>
                          </div>
                        </Col>
                      )
                    })
                  }
                </Row>
              </div>
              
              {/* Tabs Section */}
              <div className="tabs-section">
                <div className="tabs-row">
                  <div className="tabs">
                    {TEAM_OVERVIEW_TABS.map((tab) => (
                      <button
                        key={tab.key}
                        className={`tab ${activeTab === tab.key ? 'active' : ''}`}
                        onClick={() => {
                          setSearchParams({ tab: tab.key });
                          // setActiveTab(tab.key)
                        }}
                      >
                        {tab.name}
                      </button>
                    ))}
                    <div className="tab-underline" />
                  </div>

                  <ActiveFilterPills pills={activeFilterPills} />
                </div>
              </div>
            </div>

            <div className="tabs-content">
              {TEAM_OVERVIEW_TABS.find((tab) => tab.key === activeTab)?.component}
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}

export default TeamOverview